import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import CustomerDeviceModel from 'src/app/services/customerDevice.model';
import { CustomerDeviceService } from 'src/app/services/customerDevice.service';
import { BusinessEntityService } from 'src/app/services/businessEntity.service';
import BusinessEntity from 'src/app/services/businessEntity.model';
import { LocationStrategy } from '@angular/common';
import { PreviousRouteService } from 'src/app/services/previousRouteService';
import ContinuousWaterMonitoringModel from 'src/app/services/continuous-monitoring.model';
import { ContinuousWaterReadingsService } from 'src/app/services/continuous-monitoring.service';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from 'src/app/services/excelService';

declare var $: any;

@Component({
  selector: 'app-continuous-monitoring',
  templateUrl: './continuous-monitoring.component.html',
  styleUrls: ['./continuous-monitoring.component.scss']
})
export class ContinuousMonitoringComponent implements OnInit, OnDestroy {
  public customerDevices: Array<CustomerDeviceModel> = [];
  public customerDevice: CustomerDeviceModel;
  public businessEntity: BusinessEntity;
  public businessEntities: Array<BusinessEntity> = [];
  public continuousWaterReadings: Array<ContinuousWaterMonitoringModel> = [];
  public continuousWaterReading: ContinuousWaterMonitoringModel;
  public currentpagenum: number = 1;
  public noofitemsPerPage: number = 20;
  public loginPersonType: string;
  public loginUserBusinessName: string;
  public responseLoader: boolean = true;
  public isSearchClicked: any;
  public tabledatadisplay: boolean = false;
  public filename: any;
  public imageBasePath = environment.imagebaseUrl;

  constructor(
    public customerDeviceService: CustomerDeviceService,
    public businessEntityService: BusinessEntityService,
    public continuousWaterReadingsService: ContinuousWaterReadingsService,
    private locationStrategy: LocationStrategy,
    private previousRouteService: PreviousRouteService,
    private toastr: ToastrService,
    private excelService: ExcelService
  ) {
    this.continuousWaterReading = new ContinuousWaterMonitoringModel();
  }

  public async ngOnInit() {
    try {
      const businessIds = new Array();
      this.previousRouteService.setPreviousRoute(this.locationStrategy.path());
      this.loginPersonType = localStorage.getItem('loginPersonType');
      this.loginUserBusinessName = localStorage.getItem('loginBusinessName');
      this.responseLoader = true;
      this.isSearchClicked = false;
      if (this.loginPersonType !== 'Farm Manager' && this.loginPersonType !== 'Farmer' && this.loginPersonType !== 'Business Admin') {
        this.businessEntities = await this.businessEntityService.getAllBusiness();
        for (let i = 0; i < this.businessEntities.length; i++) {
          businessIds.push(this.businessEntities[i].id);
        }
        this.customerDevices = await this.customerDeviceService.getCustomerDevices(businessIds);
        this.tabledatadisplay = false;
      }
      if (this.loginPersonType === 'Farm Manager' || this.loginPersonType === 'Farmer' || this.loginPersonType === 'Business Admin') {
        this.continuousWaterReading.business_id = localStorage.businessID;
        this.customerDevices = await this.customerDeviceService.getCustomerDevices([this.continuousWaterReading.business_id]);
        this.tabledatadisplay = false;
      }
      this.tabledatadisplay = false;
    } catch (error: any) {
      this.toastr.error(error);
    }
  }

  public ngOnDestroy(): void {
    this.businessEntityService.cancelOnGoingHttpRequests();
    this.customerDeviceService.cancelOnGoingHttpRequests();
  }

  public async cwmReports() {
    if (!this.continuousWaterReading.serial_number) {
      this.toastr.warning('Please Select Device Serial Number');
      return;
    }
    try {
      this.responseLoader = false;
      this.tabledatadisplay = false;
      this.isSearchClicked = false;
      this.continuousWaterReadings = await this.continuousWaterReadingsService.getContinuousWaterReadings(this.continuousWaterReading.serial_number);
      if (this.continuousWaterReadings && this.continuousWaterReadings.length > 0) {
        this.filename = this.continuousWaterReadings[0].filename;
      }
      this.responseLoader = true;
      this.tabledatadisplay = true;
    } catch (error: any) {
      this.responseLoader = true;
      this.tabledatadisplay = false;
      this.toastr.error(error);
    }
  }

  public refereshFunction() {
    this.businessEntityService.clearCache();
    this.customerDeviceService.clearCache();
    this.ngOnInit();
  }

  public exportExcel() {
    if (this.continuousWaterReadings && this.continuousWaterReadings.length > 0) {
      this.excelService.exportAsExcelFile(this.continuousWaterReadings, 'Continuous_Monitoring_Report');
    }
  }
}
